const ImageCropperPT = {
  ImageCropper: {
    DRAG_N_CROP_IMAGE: 'Arraste um arquivo ou clique para adicionar a mídia',
    ACCEPT_TYPES: 'Extensões permitidas: ',
    INVALID_FILE_TYLE: 'Tipo de arquivo inválido!',
    FILE_SIZE_TOO_GREAT: 'O tamanho do arquivo deve ser menor que 1GB!',
    CLEAN_TEXT: 'Limpar',
    SAVE_TEXT: 'Salvar',
    UPLOAD_ERROR_MESSAGE: 'Houve um problema ao gravar, tente novamente mais tarde!',
  },
};

const ImageCropperEN = {
  ImageCropper: {
    DRAG_N_CROP_IMAGE: 'Drag-n-drop a file or click to add the media',
    ACCEPT_TYPES: 'Accepted file types: ',
    INVALID_FILE_TYLE: 'Invalid file type!',
    FILE_SIZE_TOO_GREAT: 'File size must be less than 1GB!',
    CLEAN_TEXT: 'Clean',
    SAVE_TEXT: 'Save',
    UPLOAD_ERROR_MESSAGE: 'There was a problem recording, try again later!',
  },
};

export { ImageCropperPT, ImageCropperEN };
